import actualServices from './components/actual_service/reducer'
import actualServiceGroups from './components/actual_service_group/reducer'
import actualServiceTypes from './components/actual_service_type/reducer'

const actualservice = { actualServices, actualServiceGroups, actualServiceTypes }

export {
  actualservice
}